import type { GetInviteInfoQuery } from '@affine/graphql';
import { useI18n } from '@affine/i18n';
import { BRAND_DISPLAY_NAME } from '@streamlain/brand';

import { Avatar } from '../../ui/avatar';
import * as styles from './styles.css';

export const InviteSummary = ({
  inviteInfo,
  fallbackWorkspaceName = BRAND_DISPLAY_NAME,
}: {
  inviteInfo?: GetInviteInfoQuery['getInviteInfo'];
  fallbackWorkspaceName?: string;
}) => {
  const t = useI18n();
  const workspaceName = inviteInfo?.workspace.name ?? fallbackWorkspaceName;
  const inviterName = inviteInfo?.user.name ?? '';
  const workspaceAvatar = inviteInfo?.workspace.avatar
    ? `data:image/png;base64,${inviteInfo.workspace.avatar}`
    : '';

  return (
    <div className={styles.inviteSummary}>
      <div className={styles.inviteLine}>
        <Avatar
          url={inviteInfo?.user.avatarUrl || ''}
          name={inviterName}
          size={20}
        />
        <span className={styles.inviteName}>{inviterName}</span>
      </div>
      <div className={styles.inviteSentence}>
        {t['com.streamlain.invite.invited-to-workspace']()}
      </div>
      <div className={styles.inviteWorkspaceLine}>
        <Avatar
          url={workspaceAvatar}
          name={workspaceName}
          size={32}
          colorfulFallback
        />
        <span className={styles.inviteName}>{workspaceName}</span>
      </div>
    </div>
  );
};
